import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import { LoginGate } from "./LoginGate";
import { BrandLockup } from "./BrandLockup";
import { useAuth } from "./AuthProvider";

const NAV = [
  { section: "Home", to: "/", label: "Overview", end: true, blurb: "What is blocked today, then the week's traffic and shelf." },
  { section: "Growth", to: "/waitlist", label: "Waitlist", blurb: "Who asked for the app, and which page brought them." },
  { section: "Growth", to: "/growth", label: "Analytics", blurb: "Where visits turn into outbound clicks." },
  { section: "Content", to: "/content", label: "Posts", blurb: "Which pieces are live, and how the card reads." },
  { section: "Supply", to: "/merchants", label: "Merchants", blurb: "Whether a partner can earn, and the rate on each click." },
  { section: "Supply", to: "/listings", label: "Listings", blurb: "Whether a product can sit on the public shelf." },
  { section: "Supply", to: "/settlement", label: "Settlement", blurb: "Estimated commission from clicks. Not money collected." },
  { section: "Commerce", to: "/affiliate", label: "Affiliate", blurb: "Whether plan-page booking links are filled in." },
  { section: "Catalog", to: "/destinations", label: "Destinations", blurb: "Whether a city card is complete. Public guides still live on the site." },
  { section: "Catalog", to: "/experiences", label: "Experiences", blurb: "Ops records. Public cards follow published listings, not this table." },
  { section: "Community", to: "/ugc", label: "UGC moderation", blurb: "Decide what visitors wrote. Pending items stay off the site." },
  { section: "Admin", to: "/operators", label: "Operators", blurb: "Who can change the shelf, content, and rates." },
] as const;

export function OpsLayout() {
  const { isAuthenticated } = useAuth();
  const { pathname } = useLocation();

  if (!isAuthenticated) return <LoginGate />;

  const current =
    NAV.find((item) => item.to === pathname) ||
    (pathname.startsWith("/content/")
      ? { section: "Content", label: "Edit post", blurb: "Update one published piece." }
      : { section: "Ops", label: "Ops", blurb: "" });

  let lastSection = "";
  return (
    <div className="ops-shell">
      <aside className="ops-sidebar">
        <div className="ops-sidebar__brand">
          <BrandLockup />
        </div>
        <nav className="ops-nav" aria-label="Ops">
          {NAV.map((item) => {
            const show = item.section !== lastSection;
            lastSection = item.section;
            return (
              <div key={item.to}>
                {show ? <p className="ops-nav__section">{item.section}</p> : null}
                <NavLink end={"end" in item ? item.end : false} to={item.to}>
                  {item.label}
                </NavLink>
              </div>
            );
          })}
        </nav>
        <div className="ops-sidebar__foot">
          <a href="https://chinapie.ai" rel="noreferrer" target="_blank">
            View site
          </a>
        </div>
      </aside>
      <div className="ops-main">
        <header className="ops-topbar">
          <p className="ops-crumb">
            <span>ChinaPie</span>
            <span aria-hidden="true">/</span>
            <span>{current.section}</span>
          </p>
          <UserMenu />
        </header>
        <main className="ops-content">
          <div className="ops-page">
            <header className="ops-page__head">
              <p className="ops-kicker">{current.section}</p>
              <h1>{current.label}</h1>
              {current.blurb ? <p>{current.blurb}</p> : null}
            </header>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}

function UserMenu() {
  const { profile, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const name = profile?.name || "Signed in";
  const role = profile?.role || "";
  const initial = name.trim().charAt(0).toUpperCase() || "C";

  return (
    <div className="ops-user">
      <button className="ops-user__btn" onClick={() => setOpen((v) => !v)} type="button">
        <span className="ops-user__avatar" aria-hidden="true">{initial}</span>
        <span className="ops-user__name">{name}</span>
        {role ? <span className="ops-user__role">{role}</span> : null}
      </button>
      {open ? (
        <div className="ops-user__menu">
          {role === "admin" ? (
            <NavLink onClick={() => setOpen(false)} to="/operators">
              运营管理
            </NavLink>
          ) : null}
          <button onClick={logout} type="button">
            Sign out
          </button>
        </div>
      ) : null}
    </div>
  );
}
